'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function leftPad(value, width, pad) {
    if (width === void 0) { width = 2; }
    if (pad === void 0) { pad = '0'; }
    var result = (value || '').toString();
    var length = result.length;
    while (length < width) {
        result = pad + result;
        length++;
    }
    return result;
}
function isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
}
function getWeekDay(day) {
    return day === 0 ? 7 : day;
}
function getDateParts(date) {
    return {
        dayOfMonth: date.getDate(),
        day: getWeekDay(date.getDay()),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
        hours: date.getHours(),
        minutes: date.getMinutes(),
        seconds: date.getSeconds()
    };
}
function toStringHash(obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj).reduce(function (result, key) {
        var value = obj[key];
        if (value !== null && typeof value !== 'undefined') {
            if (typeof value === 'string') {
                result[key] = value;
            }
            else if (typeof value === 'number' && !isNaN(value)) {
                result[key] = value.toString(10);
            }
        }
        return result;
    }, {});
}

exports.getDateParts = getDateParts;
exports.getWeekDay = getWeekDay;
exports.isValidDate = isValidDate;
exports.leftPad = leftPad;
exports.toStringHash = toStringHash;
//# sourceMappingURL=utils.js.map
